export const toolEntityIdParamName = "toolEntityId";

/** Skill names a tool can require and `registerSkill` can register. */
export const operatorSkillNames = [
  "canvas-builder",
  "beefree_dnd_editing",
  "conversational-workflow-builder",
  "page-controls",
  "product-alert-builder",
  "sms-pumping",
] as const;

/**
 * Tool JSON Schema description for `toolEntityId`.
 * Shared by Gemini, OpenAI Responses, and future providers that inject this parameter.
 */
export const toolEntityIdParamSchemaDescription =
  "The id of the target UI element to act on. Match the element's id from read_current_page.";

/**
 * Builds the JSON Schema description for `toolEntityId`, listing allowed enum values inline
 * so the model sees the current ids. Tools that carry this enum are deferred
 * (`defer_loading`) and do not sit in the cached tool prefix.
 *
 * @param toolEntityIds Registered entity ids for this tool name.
 * @returns Description string for the `toolEntityId` parameter.
 */
export const buildToolEntityIdParamSchemaDescription = (toolEntityIds: string[]): string => {
  return `${toolEntityIdParamSchemaDescription} Allowed values: ${toolEntityIds.join(", ")}.`;
};
